
import { fetchPublicHolidays, fetchSchoolHolidays } from '@/api/extern/openholidays';
import { fetchCalendarLists, ListHeaderType, ListScopeType } from '@/api/lists';
import { adjustColor } from '@/lib/colors';
import { getOrganization } from '@/store/auth/authSlice';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/react/daygrid';
import deAtLocale from '@fullcalendar/react/locales/de-at';
import '@fullcalendar/react/skeleton.css'; // ALWAYS NEED SKELETON
import themePlugin from '@fullcalendar/react/themes/classic';
import '@fullcalendar/react/themes/classic/palette.css'; // YOUR THEME'S PALETTE
import '@fullcalendar/react/themes/classic/theme.css'; // YOUR THEME
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';

export const Route = createFileRoute('/_auth/calendar')({
    component: CalendarComponent,
})

function CalendarComponent() {

    const sessionOrganization = useSelector(getOrganization);

    const getEventColor = (listHeader: ListHeaderType) => {
        const enhancedListHeader = listHeader as ListHeaderType & { listScopes?: ListScopeType[] };
        if (enhancedListHeader.listScopes && enhancedListHeader.listScopes.length > 0) {
            const sessionScope = enhancedListHeader.listScopes.find((scope) => scope.section && scope.section.color);
            if (sessionScope && sessionScope.section) {
                return sessionScope.section.color;
            }
            const sessionLeaderScope = enhancedListHeader.listScopes.find((scope) => scope.sectionLeader && scope.sectionLeader.color);
            if (sessionLeaderScope && sessionLeaderScope.section) {
                return sessionLeaderScope.section.color;
            }
        }
        return sessionOrganization?.color;
    }

    const loadEvents = async (fetchInfo: { start: Date; end: Date; timeZone: string }, successCallback: (events: any[]) => void) => {
        const fetch = fetchCalendarLists(fetchInfo.start, fetchInfo.end);
        const data = await fetch;
        const events = data.filter((li) => li.startDate).map((li) => ({
            title: li.name,
            start: li.startDate && dayjs(li.startDate).format('YYYY-MM-DD') || '',
            id: li.uuid,
            allDay: true,
            backgroundColor: getEventColor(li) || sessionOrganization?.color || '#1976d2',
            color: adjustColor(getEventColor(li) || sessionOrganization?.color || '#1976d2')
        }))

        if (sessionOrganization.locationIsoCode) {
            const holidays = await fetchPublicHolidays(dayjs(fetchInfo.start).format('YYYY-MM-DD'), dayjs(fetchInfo.end).format('YYYY-MM-DD'), sessionOrganization.locationIsoCode);
            const holidayEvents = holidays.map((holiday) => ({
                title: holiday.name[0].text,
                start: holiday.startDate,
                id: 'holiday-' + holiday.startDate + '-' + holiday.endDate,
                allDay: true,
                backgroundColor: '#bbbbbb',
                color: '#000000'
            }))

            const schoolHolidays = await fetchSchoolHolidays(dayjs(fetchInfo.start).format('YYYY-MM-DD'), dayjs(fetchInfo.end).format('YYYY-MM-DD'), sessionOrganization.locationIsoCode);
            const schoolHolidayEvents = schoolHolidays.map((holiday) => ({
                title: holiday.name[0].text,
                start: holiday.startDate,
                end: dayjs(holiday.endDate).add(1, 'day').format('YYYY-MM-DD'),
                id: 'holiday-' + holiday.startDate + '-' + holiday.endDate,
                allDay: true,
                backgroundColor: '#bbbbbb',
                color: '#000000'
            }))
            const allEvents = events.concat(holidayEvents).concat(schoolHolidayEvents)
            successCallback(allEvents);
        } else {
            successCallback(events);
        }
    }

    const navigate = useNavigate();

    return (
        <FullCalendar
            plugins={[dayGridPlugin, themePlugin]}
            locale={deAtLocale}
            headerToolbar={{
                start: 'title',
                end: 'today prev,next',
            }}
            initialView="dayGridMonth"
            events={loadEvents}
            eventClick={(arg) => {
                if (!arg.event.id.startsWith('holiday-')) {
                    navigate({
                        from: '/calendar',
                        to: "/list/$listHeaderUuid",
                        params: {
                            listHeaderUuid: arg.event.id,
                        }

                    })
                }
            }
            }
            height={'100%'}
            editable={true}
        />
    )
}
